<section class="modal" id="target">
    <div class="modal_container">
        <a href="#" class="modal_close">X</a>
        <!--<iframe id="vista" style="border: 0; width: 100%; height: 720px;" [src]='vista360' width="300" height="150"></iframe>-->

        <p>Texto en el modal</p>
    </div>
</section>